module.exports = __webpack_public_path__ + "img/computerMechanism_sign.93b78aa0.png";